import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForWho() {
  const forYes = ['Amás el papel, el craft y la papelería pero querés ir más allá de Pinterest', 'Tenés materiales acumulados y proyectos sin terminar', 'Querés aprender encuadernación artesanal desde cero', 'Hacés talleres de scrapbook y necesitás más contenido para todo el año', 'Querés vender tus creaciones pero no sabés cuánto cobrar', 'Buscás un sistema completo, no tutoriales sueltos'];
  const forNo = ['Buscás un curso en video interactivo (este es un bundle PDF de alta resolución)', 'Querés un producto con envío físico (es 100% digital)', 'Esperás resultados sin práctica ni dedicación'];
  return <section className="py-16 sm:py-24 px-5 bg-brand-paper border-y border-brand-line" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <FadeIn className="text-center mb-12 sm:mb-16" data-id="element-43">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-44">
            ¿Es para mí?
          </span>
          <h3 className="text-3xl sm:text-5xl font-black text-brand-ink mt-4" data-id="element-45">
            Este bundle es para vos si...
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-46">
          <FadeIn delay={0.1} data-id="element-47">
            <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-6 sm:p-8" data-id="element-48">
              <h4 className="text-lg font-black text-emerald-800 mb-6 flex items-center gap-2" data-id="element-49">
                <CheckCircle2Icon className="w-6 h-6 text-emerald-600" data-id="element-50" />
                SÍ es para vos
              </h4>
              <ul className="space-y-4" data-id="element-51">
                {forYes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-52">
                    <CheckCircle2Icon className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" data-id="element-53" />
                    <span className="text-emerald-900 text-sm leading-relaxed" data-id="element-54">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-55">
            <div className="bg-red-50 border border-red-200 rounded-2xl p-6 sm:p-8" data-id="element-56">
              <h4 className="text-lg font-black text-red-800 mb-6 flex items-center gap-2" data-id="element-57">
                <XCircleIcon className="w-6 h-6 text-red-500" data-id="element-58" />
                NO es para vos si...
              </h4>
              <ul className="space-y-4" data-id="element-59">
                {forNo.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-60">
                    <XCircleIcon className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-61" />
                    <span className="text-red-900 text-sm leading-relaxed" data-id="element-62">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-8 pt-6 border-t border-red-200" data-id="element-63">
                <p className="text-red-700 text-sm font-semibold" data-id="element-64">
                  Preferimos ser honestas. Este bundle es para crafteras que
                  quieren aprender haciendo, con un sistema real y a su propio
                  ritmo.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}